export default "__VITE_ASSET__D6H$LyrY__"